module.exports = __webpack_public_path__ + "img/home-hero.07d43ddc.png";